import { render, staticRenderFns } from "./PreviewSetButton.vue?vue&type=template&id=55f45c11&scoped=true&"
import script from "./PreviewSetButton.vue?vue&type=script&lang=ts&"
export * from "./PreviewSetButton.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewSetButton.vue?vue&type=style&index=0&id=55f45c11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f45c11",
  null
  
)

export default component.exports